import { ENDPOINTS } from "../../redux/apiConfig";

export const handleVerifyGmail = (displayName, onSuccess, onClose) => {
  const url = `${ENDPOINTS.BS_GMAIL.GMAIL_AUTH}?displayName=${encodeURIComponent(displayName)}`;

  const popup = window.open(url, "Gmail OAuth", "width=500,height=600");

  //  LISTEN FOR SUCCESS MESSAGE
  const messageListener = async (event) => {
    console.log(event);
    if (event.data?.type === "GMAIL_CONNECTED") {
      window.removeEventListener("message", messageListener);

      //  CALL YOUR SAVE API HERE
      if (onSuccess) {
        console.log(event.data?.email);

      console.log(event.data.authId)
        onSuccess({
          email: event.data?.email || event.data?.userEmail || null,
          authId:event.data?.authId || null,
        }); // this will create IntegrationAccessBS
      }

      if (onClose) {
        onClose();
      }
    }
  };

  window.addEventListener("message", messageListener);

  // fallback (if user closes manually)
  const timer = setInterval(() => {
    if (popup.closed) {
      clearInterval(timer);
      window.removeEventListener("message", messageListener);

      console.log("Popup closed");

      if (onClose) onClose();
    }
  }, 1000);
};
